import { withDefaultErrorBoundary } from '@/modules/shared/hoc/withDefaultErrorBoundary';

import { GpsPageContent } from './GpsPageContent';

// GPS data configuration page
export const GpsPage = withDefaultErrorBoundary(GpsPageContent)
